import { render } from "./StudentPeriodAttendanceView.vue?vue&type=template&id=1819dc37"
import script from "./StudentPeriodAttendanceView.vue?vue&type=script&lang=js"
export * from "./StudentPeriodAttendanceView.vue?vue&type=script&lang=js"

import "./StudentPeriodAttendanceView.vue?vue&type=style&index=0&id=1819dc37&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__